import React from 'react';
import { apiDocStyles } from '../styles/apiDocStyles';
import MethodBadge from './MethodBadge';

const EndpointCard = ({ endpoint, onClick }) => {
  return (
    <div
      style={{
        ...apiDocStyles.endpointCard,
        cursor: 'pointer',
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={apiDocStyles.endpointCardHeader}>
        <MethodBadge method={endpoint.method} />
        <span style={{
          fontFamily: 'Monaco, Consolas, "Courier New", monospace',
          fontSize: '14px',
          color: '#374151',
        }}>
          {endpoint.path}
        </span>
      </div>
      <div style={apiDocStyles.endpointCardTitle}>
        {endpoint.name}
      </div>
      <div style={apiDocStyles.endpointCardDescription}>
        {endpoint.description}
      </div>
    </div>
  );
};

export default EndpointCard;
